// extracted by mini-css-extract-plugin
module.exports = {"container":"Landing_container__1VYT4","link":"Landing_link__16Eq7"};